import axios from 'axios'

class TicketSystemService {
    constructor() {
        this.api = axios.create({
            baseURL: process.env.VUE_APP_GET_HOST,
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiZ2tkc2l0ZSIsIlVzZXJDbGFpbXMiOiJ7XCJMb2dpblwiOlwiZ2tkc2l0ZVwiLFwiRW1haWxcIjpcImdrZHNpdGVAZ2tka3JlbWwucnVcIixcIklkXCI6XCIyOWRkNWQwMy00YzNjLTRkYzktOGZmMS00M2YzNjYwMWM1NTRcIixcIkZpcnN0TmFtZVwiOlwi0KHQsNC50YJcIixcIkxhc3ROYW1lXCI6XCLQk9Ca0JRcIixcIk1pZGRsZU5hbWVcIjpcItCe0YTQuNGG0LjQsNC70YzQvdGL0LlcIixcIklzU2VydmljZVwiOmZhbHNlLFwiQWNjZXNzVG9rZW5JZGVudGl0eVNlcnZlclwiOm51bGwsXCJBZGRpdGlvbmFsUHJvcGVydGllc1wiOnt9LFwiUm9sZXNcIjpbXCJLcmVtbGluQ2FzaGllclwiXX0iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJLcmVtbGluQ2FzaGllciIsIm5iZiI6MTU5NDAzNjg2MiwiZXhwIjoxNTk5MjIwODYyLCJpc3MiOiJDcmVtbGluV2ViQXBpIiwiYXVkIjoiaHR0cDovL2xvY2FsaG9zdCJ9.Qp847Uje3fDDVRpNVMs876F9KlH9v_E76AKBy_UN3z4'
            }
        });
    }

    getPerformanceCard(performanceID) {
        return this.api.get(`/TicketEditor/GetPerformanceCard?id=${performanceID}`);
    }

    getPerformanceHallPlan(performanceID) {
        return this.api.get(`/Ticket/GetPerformanceHallPlan?performanceId=${performanceID}`);
    }

    getPerformanceTickets(performanceID, sectionID) {
        return this.api.get(`/Ticket/GetPerformanceTickets?PerformanceId=${performanceID}&SectionId=${sectionID}`);
    }
}

export default TicketSystemService;
